import { yupResolver } from '@hookform/resolvers/yup';
import { ICardProductFormMeta } from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/cardProduct/formMeta/cardProductFormMeta';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

type Props = {
    meta: ICardProductFormMeta,
    children: React.ReactNode
} & TFormUIProps;

const CardProductFormUI: React.FC<Props> = ({ onSubmit, isLoading, isSubmitting, meta, children }) => {

    const methods = useForm({ resolver: yupResolver(meta.schema) });
    
    const {
        handleSubmit,
    } = methods;

    return (
        <FormProvider {...methods}>
            <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
                {children}
                
                <CC.HStack my={4} justifyContent={'flex-end'}>
                    <CustomSaveBtn isLoading={isLoading} isSubmitting={isSubmitting} />
                </CC.HStack>
            </CC.Box>
        </FormProvider>      
    );
};

export default CardProductFormUI;
